import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

import lawyer_1 from "../assets/lawyer_2.png";
import law_scale_3 from "../assets/law_scale_3.jpg";
import judge_gavel_table_scaled_1 from "../assets/judge_gavel_table_scaled_1.jpg";

const Home = () => {
  const navigate = useNavigate();

  const slides = [
    {
      title: "Welcome to Yadi Legal Services",
      subtitle: "YOUR LEGAL PARTNER",
      desc: "Experienced legal professionals providing comprehensive legal services",
      image: law_scale_3,
    },
    {
      title: "We Fight for Justice",
      subtitle: "LEGAL EXPERTISE",
      desc: "Protecting your rights with dedication and integrity",
      image: judge_gavel_table_scaled_1,
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="home-page">
      {/* Hero CTA Section */}
      <div className="law-hero">
        <div className="law-image-section">
          <img
            src={lawyer_1}
            alt="Professional Lawyer"
            className="hero-lawyer"
          />
        </div>

        <div className="law-content-section">
          <h3 className="hero-tagline">Together We</h3>
          <h1 className="hero-title">Uphold Justice</h1>

          <p className="hero-subtitle">WE WILL DEFEND YOUR LEGAL RIGHTS</p>

          <p className="hero-desc">
            Yadi Legal Services brings you legal expertise, compassion, and a
            relentless pursuit of justice.
          </p>

          <div className="hero-buttons">
           <button
  className="btn-primary"
  onClick={() => navigate("/contact-us")}
>
  Contact
</button>

<button
  className="btn-outline"
  onClick={() => navigate("/contact-us#form")}
>
  Book Appointment
</button>
          </div>
        </div>

        {/* Social Media Sidebar */}
        <div className="law-social-sidebar">
          <a href="#" aria-label="Facebook">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="#" aria-label="Twitter">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="#" aria-label="Instagram">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="#" aria-label="Search">
            <i className="fas fa-search"></i>
          </a>
        </div>
      </div>

      {/* Background Slide Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage: `url(${slides[current].image})`,
        }}
      >
        <div className="container hero-slide-content">
          <h1>{slides[current].title}</h1>
          <h2>{slides[current].subtitle}</h2>
          <p>{slides[current].desc}</p>
        </div>
      </section>

      {/* Why Choose Us */}
      <div className="why-choose-us">
        <div className="container">
          <h2>Why Choose Yadi Legal Services</h2>

          <div className="benefits-grid-1">
            <div className="benefit-card-1">
              <i className="fas fa-gavel"></i>
              <h4>Experienced Advocates</h4>
              <p>Deep legal expertise across various domains.</p>
            </div>

            <div className="benefit-card-1">
              <i className="fas fa-user-friends"></i>
              <h4>Client-Centric Approach</h4>
              <p>Focused on understanding your unique needs.</p>
            </div>

            <div className="benefit-card-1">
              <i className="fas fa-comments"></i>
              <h4>Transparent Communication</h4>
              <p>We keep you informed every step of the way.</p>
            </div>

            <div className="benefit-card-1">
              <i className="fas fa-clock"></i>
              <h4>Quick Turnaround</h4>
              <p>Fast service without compromising quality.</p>
            </div>

            <div className="benefit-card-1">
              <i className="fas fa-shield-alt"></i>
              <h4>Trusted Reputation</h4>
              <p>Built over years of consistent legal results.</p>
            </div>

            <div className="benefit-card-1">
              <i className="fas fa-scale-balanced"></i>
              <h4>Ethical Practice</h4>
              <p>Committed to integrity and fairness in all dealings.</p>
            </div>

            <div className="benefit-card-1">
              <i className="fas fa-book"></i>
              <h4>In-Depth Research</h4>
              <p>
                Cases are backed by thorough legal research and documentation.
              </p>
            </div>

            <div className="benefit-card-1">
              <i className="fas fa-handshake"></i>
              <h4>Personalized Service</h4>
              <p>
                Every client gets attention and tailored legal solutions.
              </p>
            </div>
          </div>

          <button
            className="cta-button"
             onClick={() => navigate("/contact-us")}
          >
            Approach Us
          </button>
        </div>
      </div>

      {/* Disclaimer Section */}
      <section className="disclaimer">
        <div className="container">
          <h2>DISCLAIMER & CONFIRMATION</h2>
          <p>
            As per the rules of the Bar Council of India, we are not permitted
            to solicit work and advertise.
          </p>
          <p>
            The information provided under this website is solely available at
            your request for informational purposes.
          </p>
        </div>
      </section>

      {/* About Us Preview */}
      <section className="about-preview">
        <div className="container">
          <h2>About Us</h2>
          <button
            className="know-more-button"
            onClick={() => navigate("/about-us")}
          >
            Know More
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;